import { getContactByPhoneNumber } from 'services/pod';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetContactRequest } from 'services/pod/types';

interface IProps {
  crmId: number;
  phone: string;
}

export const ThunkGetContactByPhoneNumber = createAsyncThunk<IGetContactRequest, IProps>(
  'pod/getContactByPhoneNumber',
  async payload => {
    const r = await getContactByPhoneNumber(payload);
    return r.data;
  },
);
